import React from "react";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { API_BASE } from "APP_ROOT/constants";
import { Map } from "immutable";

export default function DownloadLot({ open, close, lot }) {
  const lotId = lot.get("id");

  const handleDownload = itemized => {
    const downloadUrl = `${API_BASE}/lots/${lotId}/download?itemized=${itemized}`;
    window.location.href = downloadUrl;
    close();
  };

  return (
    <Modal open={open} close={close} dialogClass="modal-sm">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Download Lot PO</h4>
      </Header>
      <div className="modal-body text-center">
        <p>Select the type of Lot PO download:</p>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => handleDownload(true)}
          style={{ marginRight: "10px" }}
        >
          Itemized
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => handleDownload(false)}
          style={{ backgroundColor: "#6c757d", borderColor: "#6c757d" }}
        >
          Non-Itemized
        </button>
      </div>
    </Modal>
  );
}

DownloadLot.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  lot: PropTypes.instanceOf(Map).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/DownloadLot/DownloadLot.jsx